import { namespace } from 'vuex-class';
import { ISearchState } from '@/topbar/search/store/search.types';

export const Search = namespace('search');

export enum ESearchAction {
  Search = 'search',
  SearchSuccess = 'searchSuccess',
  SearchFailed = 'searchFailed',
  ShowSearchInput = 'showSearchInput',
  ClearData = 'clearData',
}

export enum ESearchMutation {
  SetQuery = 'setQuery',
  SetState = 'setState',
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetResult = 'setResult',
  SetSearchInputVisibility = 'setSearchInputVisibility',
}

export const getDefaultState = (): ISearchState => ({
  loading: false,
  loaded: false,
  showSearchInput: false,
  query: '',
  result: {
    documents: [],
    contacts: [],
  },
});
